<ng-container>
    <div class="flex items-center justify-between w-full mx-auto px-4 py-2 pb-4">
        <div>
            <h1 class="text-xl font-semibold" [textContent]="dailogTitle"></h1>
        </div>
        <material-button [buttonType]="'icon'" [size]="'small'" [titleText]="'Close'" [prefixIcon]="'close'" mat-dialog-close [classList]="['focus:!outline-none', 'hover:!bg-gray-100']"></material-button>
    </div>
</ng-container>

<ng-container>
    <mat-dialog-content class="w-full h-[76%] overflow-auto px-4 py-2 relative !left-[15px]">
        <ng-container *ngIf="showingInstanceAttributes">
            <div class="pt-[20px] px-[40px] pb-0">
                <div class="p-[10px] bg-[#ececec]" [textContent]="translateMsg('Pre-Captured Attributes')"></div>
                <div class="m-0 p-[0_30px] relative min-h-[150px] row" *ngIf="filingAttributes.length > 0; else noPrecapturedAttributes">
                    <ng-container *ngFor="let recordField of filingAttributes; trackBy: trackByMethod">
                        <div class="flex-1 min-w-[33.33%] mt-[10px] max-w-[33.33%]" *ngIf="recordField.isPrecaptured">
                            <div>
                                <strong class="inline-block align-middle leading-[40px]" [textContent]="recordField.displayName"></strong>
                                <span class="inline-block align-middle leading-[24px] ml-[10px] rotate-45" *ngIf="recordField.isBusinessKey">vpn_key</span>
                            </div>
                            <ng-container *ngIf="recordField.value">
                                <div [title]="recordField.value" [textContent]="recordField.value !== undefined ? recordField.value : '--'"></div>
                            </ng-container>
                            <ng-container *ngIf="recordField.values && recordField.values.length > 0">
                                <div [title]="recordField.values.join(',')">
                                    <span [textContent]="recordField.values !== undefined ? recordField.values.join(',') : '--'"></span>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="checkPrecaptureField">
                        <div>
                            <span [textContent]="translateMsg('No precaptured attributes.')"></span>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="showingInstanceStatus">
            <div class="flex flex-col justify-center items-center h-full">
                <div class="w-[250px] h-[150px] relative shadow-lg rounded-md overflow-hidden">
                    <div class="text-lg font-bold p-[10px] text-white text-[15px] text-center bg-[#828387]" [textContent]="'Integration Status'"></div>
                    <div class="mt-2 flex items-center justify-center relative top-[20%]">
                        <span>
                            <span [textContent]="translateMsg('Status') + ' - '"></span>
                            <span [ngClass]="changeTextColor(integrationStatus)" [textContent]="integrationStatus"></span>
                        </span>
                        <material-button *ngIf="integrationStatus === 'Failed'" [text]="translateMsg('Re-run Integration')" [color]="'primary'" class="mt-4"></material-button>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="showingNotifications">
            <div class="relative pt-1 pb-3 left-3">
                <span [textContent]="translateMsg('Please refresh to get the latest notifications') + '.'"></span>
            </div>
            <div class="relative flex justify-between">
                <ng-container *ngIf="eventTypesList && eventTypesList.length > 0">
                    <mat-form-field class="col-5">
                        <mat-select [(ngModel)]="selectedEventType" [placeholder]="translateMsg('Event Type')" (ngModelChange)="getAllNotifications()">
                            <mat-option value=""><span [textContent]="translateMsg('All')"></span></mat-option>
                            <mat-form-field class="p-3">
                                <input matInput [placeholder]="translateMsg('Search Events')" type="text" [(ngModel)]="allAssetsName" (keydown.space)="$event.stopPropagation()" />
                                <material-button buttonType="icon" matSuffix [prefixIcon]="allAssetsName ? 'close' : 'search'" [prefixIconType]="'material'" [classList]="['[font-size:19px]']" (buttonClicked)="allAssetsName = ''"></material-button>
                            </mat-form-field>
                            <mat-option *ngFor="let event of eventTypesList || [] | multiFilter : allAssetsName | AlphabeticalOrder : 'displayName'; trackBy: trackEventType" [value]="event.id"><span [textContent]="event.displayName"></span></mat-option>
                        </mat-select>
                    </mat-form-field>
                </ng-container>
                <div>
                    <material-button [buttonType]="'mini-fab'" [titleText]="translateMsg('Process Logs')" [prefixIcon]="'event_note'" (buttonClicked)="openProcessLogs()"></material-button>
                    <material-button [buttonType]="'mini-fab'" class="mx-2" [titleText]="translateMsg('Refresh')" [prefixIcon]="'refresh'" (buttonClicked)="openProcessLogs()"></material-button>
                </div>
            </div>
            <div *transloco="let translateMsg" class="relative left-3">
                <material-table [allTableColumns]="allTableColumns" [selectedColumns]="selectedColumns" [data]="tableData" [noLog]="true" [pagination]="$any(pagination)" (refreshItemsWithNewPageSize)="refreshItemsWithNewPageSize($event)" (fetchItemsInPage)="fetchItemsInPage($event)" [noRecordMsg]="translateMsg('No Event Logs Available')"></material-table>
            </div>
        </ng-container>
        <ng-container *ngIf="showingProcessesUploadFiles">
            <div class="pl-[12px]">
                <div class="items-center">
                    <div class="font-semibold">
                        <label [textContent]="translateMsg('Select a transformation to upload a file') + ':'"></label>
                    </div>
                    <div class="w-[34%] mt-[5px]">
                        <material-selectgroup [required]="true" [options]="transformations" [placeholder]="translateMsg('Select Transformation')" [model]="selectedTransformationName" [optionDisplayNameProperty]="'displayName'" [optionValueProperty]="'id'" (modelChange)="selectedTransformationName = $event; getSelectedTransformation()" [groupDisplayNameProperty]="'orgName'" [title]="selectedTransformationName" [groupValueProperty]="'transformations'" [errors]="transformationErrors"></material-selectgroup>
                    </div>
                </div>
                <div class="mt-[30px]" *ngIf="selectedTransformationName && selectedTransformationName.length > 0">
                    <source-table [sourceParts]="sourceTableData" [sourceTableColumns]="sourceTableColumns" [hidePaginator]="hidePaginator" [primaryColumns]="primaryColumns" (downloadSourceTemplateUrl)="downloadSourceTemplateUrl($event)"></source-table>
                </div>
            </div>
        </ng-container>
        <ng-template #noPrecapturedAttributes>
            <div class="flex items-center justify-center h-full text-center">
                <span class="relative top-[100px]" [textContent]="translateMsg('No precaptured attributes.')"></span>
            </div>
        </ng-template>
    </mat-dialog-content>
    <mat-dialog-actions class="!min-h-0 flex justify-center items-center max-h-[30px]">
        <material-button [text]="translateMsg('Close')" (buttonClicked)="closeModal()"></material-button>
        <div class="d-flex justify-content-end px-4 py-0" *ngIf="selectedTransformationName && selectedTransformationName.length > 0">
            <material-button [text]="translateMsg('Upload Data')" [color]="'primary'" (buttonClicked)="validateUploadProcessesData()"></material-button>
        </div>
    </mat-dialog-actions>
</ng-container>
